import React, { createContext, useContext, useCallback, useRef, useState } from 'react';
import AgentWidget from '../components/AgentWidget';

interface MeoContextType {
  setOnPriceAgreed: (cb: ((price: number) => void) | null) => void;
  setOnNegotiationStart: (cb: (() => void) | null) => void;
  setShowMeo: (show: boolean) => void;
}

const MeoContext = createContext<MeoContextType | null>(null);

export const useMeoContext = () => {
  const ctx = useContext(MeoContext);
  if (!ctx) throw new Error('useMeoContext must be used within MeoProvider');
  return ctx;
};

export const MeoProvider = ({ children }: { children: React.ReactNode }) => {
  const [showMeo, setShowMeo] = useState(false);
  const onPriceAgreedRef = useRef<((price: number) => void) | null>(null);
  const onNegotiationStartRef = useRef<(() => void) | null>(null);

  const setOnPriceAgreed = useCallback((cb: ((price: number) => void) | null) => {
    onPriceAgreedRef.current = cb;
  }, []);

  const setOnNegotiationStart = useCallback((cb: (() => void) | null) => {
    onNegotiationStartRef.current = cb;
  }, []);

  return (
    <MeoContext.Provider value={{ setOnPriceAgreed, setOnNegotiationStart, setShowMeo }}>
      {children}
      {showMeo && (
        <AgentWidget
          company={null}
          onPriceAgreed={(price: number) => onPriceAgreedRef.current?.(price)}
          onNegotiationStart={() => onNegotiationStartRef.current?.()}
        />
      )}
    </MeoContext.Provider>
  );
};
